import { RouteType } from "types/RouteType";
import aiAgentRoute from "./AIAgent/AIAgent.Route";
import dashboardRoute from "./Dashboard/dashboard.Route";
import departmentsRoute from "./Departments/departments.Route";
import permissionsRoute from "./Permissions/permissions.Route";
import standardProceduresRoute from "./StandardProcedures/standardProcedures.Route";
import userManagementRoute from "./UserManagement/userManagement.Route";

const administrationRoutesList: RouteType[] = [
    // ...aiAgentRoute, // Hidden for now
    ...dashboardRoute,
    // departmentsRoute, // Hidden for now
    // ...permissionsRoute, // Hidden for now
    // standardProceduresRoute, // Hidden for now
    // Enabled 2026-10-05 for the Add User dialog (09-30 item 15): there is no
    // other way to add a login with a client's own email. Admin-only
    // (requiresAdmin), which at Miller-Mize is all four users.
    ...userManagementRoute,
];

export default administrationRoutesList;
